import { classSet } from '@umu/umu-dom';
import { ISearchParams, mapObjTypeToUrl, ObjListItem, PRACTICE_TYPE } from '../interface';
import { SnackBar } from '@umu/umu-design';
import { COLOR_MAP } from '../../@loadAvatar/loadAvatarUtil';

const getSessionIconClass = (sessionType: number) => {
    return classSet(
        'i',
        'icon',
        'icon-course-type',
        `icon-course-type-${sessionType}`,
        sessionType > 0 ? 'iconfont' : '',
    );
};
const getFilterParams = (param: ISearchParams) => {
    const params: ISearchParams = {};
    for (const i in param) {
        const item = param[i];
        if (item) {
            params[i] = item;
        }
    }
    return params;
};
const showMsgToast = (message: string) => {
    SnackBar.show({
        message,
    });
};
const getIdBuilder = () => {
    return String(new Date().valueOf());
};

const getPracticeUrl = (channleId: string, element?: ObjListItem & { id: string }) => {
    const practiceType = mapObjTypeToUrl[element?.obj_type || PRACTICE_TYPE.HOMEWORK_VIDEO] || 'video';
    let url = `/use#/practice/${channleId}/${practiceType}/${element?.obj_id || 'new'}`;
    element?.id && (url += `?id=${element.id}`);
    return url;
};

export { COLOR_MAP, getIdBuilder, showMsgToast, getFilterParams, getSessionIconClass, getPracticeUrl };
